import React from "react";
import { Toast } from "./Toast";
import { useToast } from "../contexts/ToastContext";

export const ToastContainer: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return (
    <div
      aria-live="assertive"
      className="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 z-[9999]"
    >
      <div className="flex flex-col items-end space-y-4 w-full">
        {toasts.map((toast) => (
          <Toast key={toast.id} {...toast} onDismiss={removeToast} />
        ))}
      </div>
    </div>
  );
};
